import type { Extension } from '../../../web-client';

/**
 * Resolves the active entry point into its `resource` bundle and `resolvedResourceEntry` (the HTML
 * entry within that bundle).
 *
 * The two come from one `<resource>/<entry>` string (see `resolveDynamicResource`), so they are
 * resolved together from a single source — never mixed. An `entryPoint` with its own resource uses
 * that bundle and entry; otherwise it borrows the top-level bundle at its default entry (the
 * top-level entry is dropped so it can't bleed into a sub-entry-point's URL).
 */
export const getExtensionEntryPoint = (
	extension: Extension,
	entryPoint?: string,
): { resolvedResourceEntry: string | undefined; resource: string } => {
	const entryPointProperties = entryPoint ? extension.properties[entryPoint] : extension.properties;

	// The entry point owns the resource+entry pair only when it declares its own resource bundle.
	if (entryPointProperties?.resource) {
		return {
			resource: entryPointProperties.resource,
			resolvedResourceEntry: entryPointProperties.resolvedResourceEntry,
		};
	}

	// Otherwise borrow the top-level resource bundle, served at its default entry (no entry carried over).
	return {
		resource: extension.properties.resource,
		resolvedResourceEntry: undefined,
	};
};
